<template>
  <svg
    class="icon"
    :height="size"
    viewBox="0 0 16 16"
    :width="size"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m2.9267767 4.03033009v5h10"
      fill="none"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="4"
      style="stroke:currentColor;"
      transform="matrix(.70710678 -.70710678 .70710678 .70710678 -2.295913 7.517775)"
    />
  </svg>
</template>

<script setup>
import { baseIconProps } from '../base/use-base-icon.js';

defineProps(baseIconProps);

</script>

